import type { MarketCar } from "@/types/market";

export function getPerformanceModelName(car?: MarketCar, fallback = "-") {
  if (car) {
    const base = `${car.make_name} - ${car.model_name}${car.variant ? ` (${car.variant})` : ""}`;
    return car.id ? `${base}\u200B${car.id}` : base;
  }
  return fallback;
}
